import { toFeatureList } from "./utils.js";

export function normalizeMachineStatus(payload, url) {
  const data = payload && typeof payload === "object" ? payload : {};
  const license = data.license && typeof data.license === "object" ? data.license : {};
  const installed = data.installed ?? data.qimeraInstalled ?? data.available;
  const licensed = data.licensed ?? license.licensed ?? data.licenseValid;
  const executablePath = data.executablePath ?? data.qimeraExecutable ?? data.path ?? "";
  const version = data.version ?? data.qimeraVersion ?? "";
  const projectRoot = data.projectRoot ?? "";
  const licenseType = license.type ?? data.licenseType ?? "";
  const features = [
    ...toFeatureList(data.licenseOptions),
    ...toFeatureList(data.features),
    ...toFeatureList(license.options),
    ...toFeatureList(license.features),
  ];
  const detail = String(data.message ?? data.detail ?? "").trim();
  return {
    sourceUrl: url,
    installed: installed === true,
    licensed: licensed === true,
    executablePath: String(executablePath || "").trim(),
    version: String(version || "").trim(),
    projectRoot: String(projectRoot || "").trim(),
    licenseType: String(licenseType || "").trim(),
    features: [...new Set(features)],
    detail,
  };
}

export async function fetchJsonWithTimeout(url, timeoutMs = 3500) {
  const ctl = new AbortController();
  const timer = setTimeout(() => ctl.abort(), timeoutMs);
  try {
    const res = await fetch(url, {
      method: "GET",
      headers: { Accept: "application/json" },
      cache: "no-store",
      signal: ctl.signal,
    });
    if (!res.ok) {
      throw new Error(`HTTP ${res.status}`);
    }
    return await res.json();
  } finally {
    clearTimeout(timer);
  }
}

export async function postJson(url, payload, timeoutMs = 120000) {
  const ctl = new AbortController();
  const timer = setTimeout(() => ctl.abort(), timeoutMs);
  try {
    const res = await fetch(url, {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      cache: "no-store",
      body: JSON.stringify(payload ?? {}),
      signal: ctl.signal,
    });
    const data = await res.json().catch(() => ({}));
    if (!res.ok) {
      throw new Error(String(data?.error || `HTTP ${res.status}`));
    }
    return data;
  } finally {
    clearTimeout(timer);
  }
}

export async function probeOpaqueUrl(url, timeoutMs = 2500) {
  const ctl = new AbortController();
  const timer = setTimeout(() => ctl.abort(), timeoutMs);
  try {
    await fetch(url, {
      method: "GET",
      mode: "no-cors",
      cache: "no-store",
      signal: ctl.signal,
    });
    return { ok: true };
  } catch (error) {
    return { ok: false, message: error?.message || "Connection failed." };
  } finally {
    clearTimeout(timer);
  }
}
